module.exports = __webpack_public_path__ + "img/marie.e2475c06.jpg";